module.exports = __webpack_public_path__ + "img/youtube.a83b530.png";